import React, {useEffect, useState} from "react";
import CustomDialog from "../../components/general/CustomDialog";
import {useTranslation} from "react-i18next";
import CustomTable, {TypeItemTable} from "../../components/general/CustomTable";
import IdentificationConsult from "../terms-conditions/IdentificationConsult";
import {useFindAudQuery} from "../../services/apis/apiPersonQuerys";
import {getMessageGeneric} from "../../services/configuration/errorHandle";
import {PaginationAuditQueryInterface} from "../../services/interface/historical/pagination-aud-query-interface";

interface Props {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export default function Record({
                                   open,
                                   setOpen
                               }: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string };

    const {
        mutate: getAudList,
        isPending: loadingAudList,
        error: errorAudList,
        data: successAudList
    } = useFindAudQuery()

    const header = [
        t('identification'),
        t('ip'),
        t('consultation-date'),
    ];

    const [list, setList] = useState<PaginationAuditQueryInterface | undefined>()
    const [listElement, setListElement] = useState<TypeItemTable[] | undefined>()
    const [index, setIndex] = useState<number | undefined>(0)

    useEffect(() => {
        if (index || index === 0) {
            getAudList({page: index})
        }
    }, [index]);

    useEffect(() => {
        if (successAudList) {
            setList(successAudList)
        }
    }, [successAudList]);

    useEffect(() => {
        if (list && list.content && list.content.length > 0) {
            setListElement(list.content?.map((item: any) => (
                {
                    row: [
                        <IdentificationConsult
                            className={'text-[13.9px] pl-2 font-light text-header'}
                            identification={item.identifier}
                            setOpenComponent={setOpen}
                        />,
                        item.publicIp,
                        item.queryDate,
                    ]
                }
            )))
        }
    }, [list]);

    return (
        <CustomDialog
            title={t('record')}
            size={'md'}
            body={
                <CustomTable
                    loading={loadingAudList}
                    error={getMessageGeneric(errorAudList, '/audit/current_user/basic_info')}
                    pagination={true}
                    header={header}
                    number={list?.number}
                    totalPages={list?.totalPages}
                    totalElements={list?.totalElements}
                    {...{listElement, setIndex}}
                />
            }
            {...{open, setOpen}}
        />
    )
}
